module.exports = __webpack_public_path__ + "static/media/botones-11.114998a1.png";